import { type SideNavSection } from '@dittolive/anvil'
import { BuildingsIcon, DatabaseIcon, UsersIcon } from '@phosphor-icons/react'
import paths from 'paths'
import { useMemo } from 'react'

type Options = {
  isSuperAdmin?: boolean
  /** Set when an admin views another user's tenant. */
  userId?: string
}

/**
 * Sidebar navigation for the personal (user tenant) context.
 *
 * When `userId` is set the viewer is an admin looking at someone else's
 * tenant, so employee groups are hidden. Personal settings live in the user
 * menu, so they aren't part of this navigation.
 */
export function usePersonalNavSections(options: Options): SideNavSection[] {
  const { isSuperAdmin, userId } = options

  return useMemo(() => {
    const sections: SideNavSection[] = [
      {
        items: [
          {
            text: 'Databases',
            to: paths.userApps({ userId }),
            icon: <DatabaseIcon />,
          },
          {
            text: 'Organizations',
            to: paths.userOrganizations({ userId }),
            icon: <BuildingsIcon />,
          },
        ],
      },
    ]

    if (isSuperAdmin && !userId) {
      sections.push({
        items: [
          {
            text: 'Employee groups',
            to: paths.userTenant({ area: 'employee-groups' }),
            icon: <UsersIcon />,
          },
        ],
      })
    }

    return sections
  }, [isSuperAdmin, userId])
}
